var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#030708"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 2h8v8h-8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 2h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 12h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12h8v8h-8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22 2h8v8h-8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22 12h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 22h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 22h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 22h8v8h-8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid9);
export default __webpack_public_path__ + "static/media/grid9.e21f0acbe07c2f3ae3f30e1d6fc747e3.svg";
export { ForwardRef as ReactComponent };